import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import * as ROUTES from '../../../../constants/routes';
import styled from 'styled-components';
import * as MDICONS from '@material-ui/icons';
import { openNewTagModal, setCurrentSnagDetailWithFloorMeta } from '../../../../store/actions/projectActions';
import ReactModal from 'react-modal';
import AddNewTagModal from './AddNewTagModal';

import { get } from 'lodash'
import UpdateTagModal from './UpdateTagModal';

class AllTagsCard extends Component {
    constructor(props) {
        super(props)

        this.state = {
            showAddTagModal: false,
            showUpdateTagModal: false,
            tagMap: null,
        }
    }

    /// README: Compare to sort
    compare(a, b) {
        if ('name' in a && 'name' in b) {
            if (a.name < b.name) {
                return -1;
            }
            if (a.name > b.name) {
                return 1;
            }
        }
        return 0;
    }

    /// README: MODAL CONTROLLING
    handleOpenModal = (num, tagMap) => {
        this.props.openNewTagModal();

        switch (num) {
            case 0: {
                this.setState({ showAddTagModal: true, showUpdateTagModal: false });
                break;
            }
            case 1: {
                this.setState({ showAddTagModal: false, showUpdateTagModal: true, tagMap, });
                break;
            }
            default: {
                this.setState({ showAddTagModal: false, showUpdateTagModal: false });
                break;
            }
        }
    }

    handleCloseModal = (num) => {
        switch (num) {
            case 0: {
                this.setState({ showAddTagModal: false });
                break;
            }
            case 1: {
                this.setState({ showUpdateTagModal: false });
                break;
            }
            default: {
                this.setState({ showAddTagModal: false, showUpdateTagModal: false });
                break;
            }
        }
    }

    render() {
        const { themeColors, alu, userData, snagDetail, modalStyles, project, commonLabels, modalInfoTextStyle } = this.props;
        const { tagCategories, tagCategory, utagCategory, utagCategories, defectMarkers, defectMarker, udefectMarkers, udefectMarker, assetPart } = commonLabels;
        const { isTagCreated } = project;
        const { uid, employeeid } = userData;
        const { accessMap } = snagDetail;
        const { createNewTagAccess } = alu;

        const ueid = uid + employeeid;

        var accessLevel = accessMap ? ueid in accessMap ? accessMap[ueid]['access'] : alu.invalid : alu.invalid;
        var hasAllTags = accessMap ? ueid in accessMap ? accessMap[ueid]['hasAllTags']:false:false;
        var selectedTagsIdList = accessMap ? ueid in accessMap ? accessMap[ueid]['selectedTagsIdList']:[]:[];
        /// create relevant button based on access level
        var newTagButton = createNewTagAccess[accessLevel] ? (<button className="btn btn-dark btn-sm " style={{ borderRadius: '9px' }} onClick={() => { this.handleOpenModal(0) }}>Add {tagCategory}</button>) : (<React.Fragment></React.Fragment>);
        var filterAllTagsMap = 'allTagsMap' in snagDetail ? Object.keys(snagDetail.allTagsMap).length > 1 ? Object.values(snagDetail.allTagsMap).sort(this.compare):[]:[];
        filterAllTagsMap = filterAllTagsMap.filter(val => (val.tagid !== "elevation"));
        filterAllTagsMap = filterAllTagsMap.filter(val=> (!val.name.includes('[DELETED]')));
        if(!hasAllTags){
            filterAllTagsMap = filterAllTagsMap.filter(val=> selectedTagsIdList.includes(val.tagid));
        }
        return (
            <div className="card p-2" style={{ borderRadius: '15px' }}>
                <div className="card-header bg-white p-0 mx-2">
                    <div className="row">
                        <div className="col-10">
                            <p style={{ textAlign: "start", fontWeight: "bold", fontSize: "18px" }}>{utagCategories}</p>
                        </div>
                        <div className="col-2">
                            {/* <MDICONS.LabelImportantRounded/> */}
                        </div>
                    </div>
                    <p style={modalInfoTextStyle}>Create appropriate tag {tagCategories} to suit the needs of the project. For example, a tag {tagCategory} can be a sub-discipline of work in the project (e.g. tiling, rendering) or a party concerned with the project (e.g. a subcontractor).</p>
                </div>
                <div className="card-body">
                    <div className="row row-cols">
                        {filterAllTagsMap? filterAllTagsMap.length >=1 ? filterAllTagsMap.map((val, i) => (
                            createNewTagAccess[accessLevel] ?
                                <div key={i} onClick={() => { this.handleOpenModal(1, val) }}>
                                    <span className="badge badge-pill mx-1 px-3" role="button" style={{ backgroundColor: `${themeColors.themeColor}`, color: "whitesmoke", textAlign: "end", fontSize: "12px" }}>{val.name}</span>
                                </div>
                                :
                                <div key={i}>
                                    <span className="badge badge-pill mx-1 px-3" role="button" style={{ backgroundColor: `${themeColors.themeColor}`, color: "whitesmoke", textAlign: "end", fontSize: "12px" }}>{val.name}</span>
                                </div>
                        )) : `No ${tagCategories} found` : `No ${tagCategories} found`}
                    </div>

                    {/* Buttons */}
                    <div className="mt-5">
                        <div className="d-flex justify-content-end">
                            <div className="d-flex flex-row">
                                <div className="align-self-center">
                                    {newTagButton}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ADD NEW TAG MODALS */}
                    <ReactModal
                        style={modalStyles}
                        isOpen={this.state.showAddTagModal && !isTagCreated === true}
                        onRequestClose={() => { this.handleCloseModal(0) }}
                        contentLabel="Add new tag"
                        ariaHideApp={false}
                    >
                        <button className="close" onClick={() => { this.handleCloseModal(0) }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <AddNewTagModal snagDetail={snagDetail} utagCategory={utagCategory} tagCategory={tagCategory} defectMarker={defectMarker} />
                    </ReactModal>

                    {/* UPDATE TAG MODALS */}
                    <ReactModal
                        style={modalStyles}
                        isOpen={this.state.showUpdateTagModal && !isTagCreated === true}
                        onRequestClose={() => { this.handleCloseModal(1) }}
                        contentLabel="Add new tag"
                        ariaHideApp={false}
                    >
                        <button className="close" onClick={() => { this.handleCloseModal(1) }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <UpdateTagModal snagDetail={snagDetail} tagMap={this.state.tagMap} utagCategory={utagCategory} tagCategory={tagCategory} />
                    </ReactModal>
                </div>
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        themeColors: state.theme,
        dashboardSidebarSize: state.appControl.dashboardSidebarSize,
        userData: state.firebase.profile,
        alu: state.alu,
        commonLabels: state.commons,
        project: state.project,
        snagDetail: get(state.firestore.data, `Snag.${state.project.proid}`),

        // styles
        modalTitleStyle: state.appControl.modalTitleStyle,
        modalInfoTextStyle: state.appControl.modalInfoTextStyle,
        modalStyles: state.appControl.modalStyles,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setCurrentSnagDetailWithFloorMeta: (snagDetail, floorMeta) => dispatch(setCurrentSnagDetailWithFloorMeta(snagDetail, floorMeta)),
        openNewTagModal: () => dispatch(openNewTagModal()),
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(AllTagsCard)
